import { generateQuery } from 'utils';
import http from 'utils/http';

export const createCustomerTask = (customerId, data) => http
  .post(`v1/organizations/{{organizationId}}/customers/${customerId}/tasks/`, data)
  .then((res) => res.data);

export const createCompanyTask = (companyId, data) => http
  .post(`v1/organizations/{{organizationId}}/companies/${companyId}/tasks/`, data)
  .then((res) => res.data);

export const getTaskAssignees = () => http
  .get('v1/organizations/{{organizationId}}/task-assignees/')
  .then((res) => res.data);

export const getTasks = (params = {}) => {
  const query = generateQuery([
    params.assignee ? `assignee=${params.assignee}` : '',
    params.status ? `status=${params.status}` : '',
    params.due_before ? `due_before=${encodeURIComponent(params.due_before)}` : '',
    params.due_after ? `due_after=${encodeURIComponent(params.due_after)}` : '',
    params.customer ? `customer=${params.customer}` : '',
    params.company ? `company=${params.company}` : '',
    params.page ? `page=${params.page}` : '',
    params.page_size ? `page_size=${params.page_size}` : '',
  ]);
  return http
    .get(`v1/organizations/{{organizationId}}/tasks/${query}`)
    .then((res) => res.data);
};

export const updateTask = (taskId, data) => http
  .patch(`v1/organizations/{{organizationId}}/tasks/${taskId}/`, data)
  .then((res) => res.data);
